export const enum EnumFinalizacaoParcial {
    QUANTIDADEPRODUTOS = 1,
    PARTES = 2,
    QUANTIDADEFRACIONADA = 3,
}